export const ranksetting = [
  {
    "rank": 100,
    "name": "Bronze",
    "png": "01_01"
  },
  {
    "rank": 200,
    "name": "Silver",
    "png": "02_01"
  },
  {
    "rank": 300,
    "name": "Gold",
    "png": "03_01"
  },
  {
    "rank": 400,
    "name": "Platinum",
    "png": "04_01"
  },
  {
    "rank": 500,
    "name": "Diamond",
    "png": "05_01"
  },
  {
    "rank": 600,
    "name": "Crown",
    "png": "06_01"
  },
  {
    "rank": 700,
    "name": "Ace",
    "png": "07"
  },
  {
    "rank": 800,
    "name": "Conqueror",
    "png": "08"
  }
];



export function getRankName(value: string | number) {
  let _rankName = '';
  ranksetting.forEach((item, index) => {
    if (value == item.rank) {
      _rankName = item.name;
      return false;
    }
  });
  return _rankName;
}
